import React from 'react'
import { Table, Button, Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { formatCurrency } from '../../utils/cart.js'

const PosProductTable = ({ sales, itemInputs, onInputChange, onAdd }) => (
  <Table
    striped
    bordered
    hover
    responsive='xl'
    className='table-sm my-2 pos-product-table'
    variant='active'
  >
    <thead>
      <tr>
        <th>Mfg</th>
        <th>Name</th>
        <th>Qty</th>
        <th>Price</th>
        <th width='190px'>Select</th>
        <th width='110px'>Disc %</th>
      </tr>
    </thead>
    <tbody>
      {sales.map(
        (unit) =>
          unit.qty > 0 && (
            <tr key={unit._id}>
              <td>{unit.manufacturer}</td>
              <td>{unit.subname}</td>
              <td className='pos-stock-cell'>{unit.qty}</td>
              <td align='right'>{formatCurrency(unit.price)}</td>
              <td>
                <Form className='d-flex align-items-center gap-2 flex-nowrap'>
                  <Form.Group
                    className='mb-0'
                    controlId={`quantity-${unit._id}`}
                  >
                    <Form.Control
                      style={{ minWidth: '72px' }}
                      type='number'
                      min='1'
                      max={unit.qty}
                      value={itemInputs[unit._id]?.quantity ?? 1}
                      aria-label={`Quantity for ${unit.subname}`}
                      onChange={(e) =>
                        onInputChange(
                          unit._id,
                          'quantity',
                          e.target.value,
                          unit.qty
                        )
                      }
                    ></Form.Control>
                  </Form.Group>
                  <Button
                    type='button'
                    variant='primary'
                    className='pos-add-button d-flex align-items-center justify-content-center gap-1'
                    onClick={() => onAdd(unit)}
                  >
                    <FontAwesomeIcon icon={faPlus} /> Add
                  </Button>
                </Form>
              </td>
              <td>
                <Form.Group className='mb-0' controlId={`discount-${unit._id}`}>
                  <Form.Control
                    style={{ minWidth: '72px' }}
                    type='number'
                    min='0'
                    max='50'
                    value={itemInputs[unit._id]?.discount ?? 0}
                    aria-label={`Discount percentage for ${unit.subname}`}
                    onChange={(e) =>
                      onInputChange(unit._id, 'discount', e.target.value)
                    }
                  ></Form.Control>
                </Form.Group>
              </td>
            </tr>
          )
      )}
    </tbody>
  </Table>
)

export default PosProductTable
